import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  type FbaFeeContent,
  type ReferralFeePatternContent,
  type StorageFeeContent,
} from "@cielo-blu-team/amazon-fee-lib-v2";

export interface FeePatternsState {
  referralFee: ReferralFeePatternContent | undefined;
  fbaFee: FbaFeeContent | undefined;
  storageFee: StorageFeeContent | undefined;
  /** 取得日時（UNIXミリ秒）。LocalStorage の TTL 判定に利用 */
  fetchedAt: number | undefined;
}

const initialState: FeePatternsState = {
  referralFee: undefined,
  fbaFee: undefined,
  storageFee: undefined,
  fetchedAt: undefined,
};

export const feePatternsSlice = createSlice({
  name: "feePatternsSlice",
  initialState,
  reducers: {
    // パターン定義を一括セット
    setFeePatterns: (
      state,
      action: PayloadAction<{
        referralFee: ReferralFeePatternContent;
        fbaFee: FbaFeeContent;
        storageFee: StorageFeeContent;
        fetchedAt: number;
      }>
    ) => {
      state.referralFee = action.payload.referralFee;
      state.fbaFee = action.payload.fbaFee;
      state.storageFee = action.payload.storageFee;
      state.fetchedAt = action.payload.fetchedAt;
    },
    // パターン定義をクリア
    clearFeePatterns: (state) => {
      state.referralFee = undefined;
      state.fbaFee = undefined;
      state.storageFee = undefined;
      state.fetchedAt = undefined;
    },
  },
});

export const { setFeePatterns, clearFeePatterns } = feePatternsSlice.actions;
